import { gql } from '@apollo/client';

export const GET_MYFORM = gql`
  query GetMyForm($input: GetMyFormInput!, $submissionIds: [ID!]) {
    myForm: getMyForm(input: $input) {
      id
      name
      monitoringForm {
        id
        name
        description
        ownerOrg {
          id
        }
        captureValue
        version
        published
        supportingDocuments
        allowCurrency
        currencies {
          id
          currencyGroup {
            id
            name
            exchangeRate
          }
        }
        period {
          id
          name
        }
        programme {
          id
          name
        }
        intervention {
          id
          name
          programme {
            id
            name
          }
        }
        dueDates {
          id
          date
          periodNumber
        }
        formReporters {
          id
          organisation {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          sites {
            id
            name
          }
        }
        reporters {
          id
          funder {
            id
            name
          }
          serviceProvider {
            id
            name
          }
          institution {
            id
            name
          }
        }
        users {
          id
          reporter {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          formRole {
            id
            name
          }
          user {
            id
            firstName
            lastName
            email
          }
          sites {
            id
            name
          }
        }
        indicators {
          id
          dimensions
          site {
            id
            name
          }
          indicator {
            id
            indicatorLabel
            measurementUnit
            type
            unit
            variable
            name
            description
            resultRelationship
            minValueAllowed
            maxValueAllowed
            statusTier
            statusType
            trackingOrganisation
            dimensions {
              id
              index
              name
            }
            periods {
              id
              periodDate
              periodNumber
              label
            }
            period {
              id
              name
            }
            progressStatusConditions {
              id
              index
              status
              operator
              value1
              value2
            }
            allStatusOverides
            calculateStatus
            trackProgressStatus
            basedOn
            targets {
              id
              value
              periodDate
              periodNumber
              dimensionOptions
              site {
                id
                name
              }
            }
          }
        }
        reporterSubmissions(ids: $submissionIds) {
          id
          updatedAt
          status
          statusDate
          periodNumber
          reporter {
            id
            funder {
              id
              name
            }
            serviceProvider {
              id
              name
            }
            institution {
              id
              name
            }
          }
          respondent {
            id
            lastName
            firstName
            email
          }
        }
        submissions(ids: $submissionIds) {
          id
          status
          urls {
            id
            link
            name
          }
          data {
            id
            indicator {
              id
              name
            }
            periodNumber
            dimensionReporter {
              id
              funder {
                id
                name
              }
              serviceProvider {
                id
                name
              }
              institution {
                id
                name
              }
            }
            dimension1
            dimension2
            dimension3
            dimension4
            dimension5
            value
            site {
              id
              name
            }
          }
        }
      }
      workspaceForm {
        id
        name
        description
        version
        published
        hasUnsubmittedSubmissions
        template {
          id
          updatedAt
        }
        dueDates {
          id
          date
          periodDate
        }
      }
    }
  }
`;
